<template>
  <div>

    <div class="card" style="background: #f5f5f5;">
      <div class="card-body" style="padding: 0.5rem !important;">
        <div class="row">
          <div class="container">
            <div class="col-sm-3 col-xl-3">
              <span style="vertical-align: -webkit-baseline-middle;">Required {{headerLabel}} as of {{lastUpdatedDateTime(progress)}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="text-center mt-4">
      <span><strong>{{title}}</strong></span>
    </div>

    <div class="row mt-4 ml-1">
      <div class="col-sm-3 col-xl-3">
        <div class="row">
          <div class="col-6 d-flex flex-wrap align-items-center">
            <div id="creditProgressChart" v-show="isPieChartGenerated" style="width: 100%; text-align: center;"></div>
          </div>
          <div class="col-6 d-flex flex-wrap align-items-center" v-if="isPieChartGenerated">
            <div class="status_row"><span class="lg_blc transferred"></span>Transferred {{legendSuffix}}</div>
            <div class="status_row"><span class="lg_blc completed"></span>Completed {{legendSuffix}}</div>
            <div class="status_row"><span class="lg_blc in_progress"></span>In Progress {{legendSuffix}}</div>
            <div class="status_row"><span class="lg_blc in_the_plan"></span>In the Plan {{legendSuffix}}</div>
            <div class="status_row"><span class="lg_blc missing"></span>Missing {{legendSuffix}}</div>
          </div>
          <div v-else class="col-12 w-100">
            <spinner size="large"></spinner>
          </div>
        </div>
      </div>
    </div>

    <div class="col-sm-3 col-xl-3">
      <div class="mt-4">
        <span style="font-size: 16px;"><i>Please contact your advisor for the exact program requirements and transferable courses.</i></span>
      </div>
      <!--
      <div class="mt-4">
        <span>Current Date {{currentDateTime()}}</span>
      </div>
      -->
      <div class="mt-3">
        <span>Last Calculated On {{lastUpdatedDateTime(progress)}}</span>
      </div>
      <div class="mt-4 float-right" style="padding-right: 0.5rem;">
        <button class="btn btn-primary" @click="recalculateCreditProgress">Re-calculate now</button>
      </div>
    </div>

    <nav class="layout-footer footer stream_footer bg-footer-theme sm_back_btn">
      <div class="container-fluid d-flex flex-wrap justify-content-between">

        <div class="back_btn">
          <b-link class="footer-link" @click="closeCreditProgressPopup">
            <span class="ic-arrow-left2"></span>
            <span class="btn_txt">back</span>
          </b-link>
        </div>

        <div class="footer_links_with_back_btn">
          <span class="footer_txt">Required {{headerLabel}} as of {{lastUpdatedDateTime(progress)}}</span>
        </div>

      </div>
    </nav>

  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import { DateTime } from 'luxon'
  import moment from 'moment'
  import { PACKAGE } from '../../../package_constants'
  import * as d3 from 'd3'

  export default {
    name: 'explore-program-guide-credit-progress',
    props: ['title', 'programId', 'streamId', 'creditProgressTargetId'],
    data: () => {
      return {
        progress: null,
        isPieChartGenerated: false
      }
    },

    mounted () {
      this.loadCreditProgress(false)
    },

    updated () {
      this.$nextTick(() => {
        if (this.progress) {
          if (this.isShowCourseProgressEnabled) {
            let colorScale = {
              'transferred courses': '#56b5e8',
              'completed courses': '#5c8c43',
              'in progress courses': '#aac76b',
              'scheduled courses': '#eb8807',
              'courses needed': '#e0291f'
            }
            this.generatePieChart(this.progress.courseValues, colorScale, 'creditProgressChart')
          } else {
            let colorScale = {
              'transferred': '#56b5e8',
              'completed': '#5c8c43',
              'in progress': '#aac76b',
              'scheduled': '#eb8807',
              'credits needed': '#e0291f'
            }
            this.generatePieChart(this.progress.values, colorScale, 'creditProgressChart')
          }
        }
      })
    },

    methods: {
      ...mapActions([
        'loadUserObj',
        'loadInstitutionPackage',
        'loadProgramCreditProgress'
      ]),

      closeCreditProgressPopup () {
        this.$parent.creditProgressTargetId = ''
        this.$parent.selectedProgramGuide = null
        this.$parent.showCreditProgressPopup = false
      },

      async loadCreditProgress (isRecalculate) {
        this.isPieChartGenerated = false
        await this.loadUserObj()
        await this.loadInstitutionPackage({uuid: this.userObj.institutionId, isAggregated: false})
        this.progress = await this.loadProgramCreditProgress({streamId: this.streamId, programId: this.programId, recalculate: isRecalculate})
      },

      generatePieChart (data, colorScale, elementId) {
        $('#' + elementId).empty()
        var pieChartContainerHeight = 162
        var pieChartInnerRadius = 35
        var width = pieChartContainerHeight
        var height = pieChartContainerHeight
        var radius = pieChartContainerHeight / 2

        var canvas = d3.select('#' + elementId).append('svg')
                     .data([data]).attr('width', width).attr('height', height).append('g')
                     .attr('transform', 'translate(' + radius + ',' + radius + ')')

        var arc = d3.arc()
                  .outerRadius(radius)
                  .innerRadius(pieChartInnerRadius)

        var pie = d3.pie()
                  .value(function (d) { return d.value }).sort(null)

        var arcs = canvas.selectAll('.arc')
                   .data(pie(data))
                   .enter().append('g')
                   .attr('class', 'arc')

        arcs.append('path')
            .attr('d', arc)
            .style('fill', function (d, i) { return colorScale[d.data.label] })

        arcs.append('text')
            .attr('transform', function (d) { return 'translate(' + arc.centroid(d) + ')' })
            .style('font', 'bold 12px Arial')
            .style('fill', '#fff')
            .style('cursor', 'default')
            .attr('text-anchor', 'middle')
            .text(function (d) { return d.data.value })

        this.isPieChartGenerated = true
      },

      changeMillisToDate (millis, format) {
        return DateTime.fromMillis(millis, {zone: 'local'}).toFormat(format)
      },

      lastUpdatedDateTime (progress) {
        return (progress) ? this.changeMillisToDate(progress.lastUpdatedTime, 'MM/dd/yyyy @ hh:mm a') : ''
      },

      currentDateTime (progress) {
        let millis = moment().valueOf()
        if (progress && progress.currentTime) {
          millis = progress.currentTime
        }
        return this.changeMillisToDate(millis, 'MM/dd/yyyy (hh:mm a)')
      },

      recalculateCreditProgress () {
        this.loadCreditProgress(true)
      }
    },

    computed: {
      ...mapState({
        'userObj': state => state.login.userObj,
        'enabledFeatures': state => state.dashboard.enabledFeatures
      }),
      headerLabel () {
        return this.isShowCourseProgressEnabled ? 'Courses' : 'Credits'
      },
      legendSuffix () {
        return this.isShowCourseProgressEnabled ? 'Courses' : ''
      },
      isShowCourseProgressEnabled () {
        let progressViewFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PROGRESS_VIEW_FEATURE_ID]
        if (progressViewFeature && progressViewFeature.enabled) {
          let flags = progressViewFeature.flags
          for (var i = 0; i < flags.length; i++) {
            if (flags[i].title === 'showCourseProgressOnOverall') {
              return flags[i].enabled
            }
          }
        }
        return false
      },
      isShowCreditProgressEnabled () {
        let progressViewFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PROGRESS_VIEW_FEATURE_ID]
        console.log('progressViewFeature: ', progressViewFeature)
        if (progressViewFeature && progressViewFeature.enabled) {
          let flags = progressViewFeature.flags
          for (var i = 0; i < flags.length; i++) {
            if (flags[i].title === 'showCreditProgress') {
              return flags[i].enabled
            }
          }
        }
        return false
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/app/explore/components/ExploreProgramGuideCreditProgress.vue